import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Alert from "@material-ui/lab/Alert";
import AlertTitle from "@material-ui/lab/AlertTitle";
import NewReleasesIcon from '@material-ui/icons/NewReleases';

const useStyles = makeStyles(() => ({
  alert: {
    margin: '16px',
  }
}));

function NewsInfo({item}){
    
    const classes = useStyles();

    return (
        <Alert icon={<NewReleasesIcon fontSize="inherit" />} severity="info" className={classes.alert}>
            <AlertTitle>{item.title}</AlertTitle>
            {item.details}
        </Alert>
    );
};

NewsInfo.propTypes = {
  item: PropTypes.object.isRequired
};

export default NewsInfo;